// src/services/supabaseApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

type InitiateSupabaseLoginArgs = void;

type ConfigureSupabaseProjectArgs = {
  app_project_id: string;
  supabase_project_ref: string;
  supabase_organization_id: string;
  supabase_project_name: string;
  supabase_project_database: any; // keep as-is
};

type ConfigureIntegrationKeysArgs = {
  app_project_id: string;
  api_keys: Record<string, string>;
};
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const supabaseApi = createApi({
  reducerPath: "supabaseApi",
  baseQuery: createCustomBaseQuery(
    `${API_BASE_URL}/supabase/`
  ),
  tagTypes: ["SupabaseProjects"],
  endpoints: (builder) => ({
    initiateSupabaseLogin: builder.mutation<any, InitiateSupabaseLoginArgs>({
      query: () => ({
        url: "login/supabase",
        method: "GET",
      }),
    }),

    // GET /supabase/projects
    getSupabaseProjects: builder.query<any, void>({
      query: () => ({
        url: "supabase/projects",
        method: "GET",
      }),
      providesTags: ["SupabaseProjects"],
    }),

    // GET /supabase/organizations
    getSupabaseOrganizations: builder.query<any, void>({
      query: () => ({
        url: "supabase/organizations",
        method: "GET",
      }),
    }),

    // POST /supabase/project/config
    configureSupabaseProject: builder.mutation<any, ConfigureSupabaseProjectArgs>({
      query: (args) => ({
        url: "projects/integrations/configure",
        method: "POST",
        body: {
          app_project_id: args.app_project_id,
          // supabase_project_ref: args.supabase_project_ref,
          // supabase_organization_id: args.supabase_organization_id,
          // supabase_project_name: args.supabase_project_name,
          // api_keys: args.supabase_project_database,
        },
      }),
    }),

    // GET /projects/integrations/{app_project_id}
    getIntegrations: builder.query<any, { app_project_id: string }>({
      query: (args) => ({
        url: `projects/integrations/${args.app_project_id}`,
        method: "GET",
      }),
    }),
    // POST /projects/integrations/configure for API keys
    configureIntegrationKeys: builder.mutation<any, ConfigureIntegrationKeysArgs>({
      query: (args) => ({
        url: "projects/integrations/configure",
        method: "POST",
        body: {
          app_project_id: args.app_project_id,
          api_keys: args.api_keys,
        },
      }),
    }),
    // POST /supabase/project/create
    createSupabaseProject: builder.mutation<any, { app_project_id: string; supabase_organization_id: string; region: string }>({
      query: (args) => ({
        url: "supabase/project/create",
        method: "POST",
        body: args,
      }),
    }),
  }),
});

export const {
  useInitiateSupabaseLoginMutation,
  useGetSupabaseProjectsQuery,
  useGetSupabaseOrganizationsQuery,
  useConfigureSupabaseProjectMutation,
  useCreateSupabaseProjectMutation,
  useGetIntegrationsQuery,
  useConfigureIntegrationKeysMutation,
} = supabaseApi;
